export enum ImageSizeEnum {
    default,
    small,
    medium
}